import { render } from "./DamageView.vue?vue&type=template&id=fe855bbc"
import script from "./DamageView.vue?vue&type=script&lang=js"
export * from "./DamageView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__